(function () {
  'use strict';

  var STATE_KEY = '__mellowShippingEta';
  var state = window[STATE_KEY];
  if (!state) {
    state = { roots: new Set(), timer: null, listeners: false, domReadyBound: false };
    window[STATE_KEY] = state;
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatDeliveryDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function nextLocalMidnight(from) {
    return new Date(from.getFullYear(), from.getMonth(), from.getDate() + 1, 0, 0, 0, 0);
  }

  function deliveryAtOrderDate(orderDay) {
    var d = new Date(orderDay.getFullYear(), orderDay.getMonth(), orderDay.getDate(), 12, 0, 0, 0);
    var businessDaysLeft = 7;
    while (businessDaysLeft > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) {
        businessDaysLeft--;
      }
    }
    return d;
  }

  function countdownParts(msLeft) {
    if (msLeft < 0) msLeft = 0;
    var totalMin = Math.floor(msLeft / 60000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    var hLabel = h === 1 ? 'Hour' : 'Hours';
    var mLabel = m === 1 ? 'Minute' : 'Minutes';
    return pad2(h) + ' ' + hLabel + ' ' + pad2(m) + ' ' + mLabel;
  }

  function updateRoot(root) {
    if (!root || !root.isConnected) return;

    var now = new Date();
    var midnight = nextLocalMidnight(now);
    var msLeft = midnight - now;

    var orderDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var delivery = deliveryAtOrderDate(orderDay);

    var countdownEl = root.querySelector('[data-mellow-shipping-eta-countdown]');
    var deliveryEl = root.querySelector('[data-mellow-shipping-eta-delivery]');
    var srEl = root.querySelector('[data-mellow-shipping-eta-sr]');

    var countdownText = countdownParts(msLeft);
    var deliveryText = formatDeliveryDate(delivery);
    var line = 'Order within ' + countdownText + ' to get it by ' + deliveryText;

    if (countdownEl) countdownEl.textContent = countdownText;
    if (deliveryEl) deliveryEl.textContent = deliveryText;
    if (srEl) srEl.textContent = line;
  }

  function tick() {
    if (state.roots.size === 0) {
      if (state.timer != null) {
        clearInterval(state.timer);
        state.timer = null;
      }
      return;
    }

    state.roots.forEach(function (root) {
      if (!root.isConnected) {
        state.roots.delete(root);
        return;
      }
      updateRoot(root);
    });

    if (state.roots.size === 0 && state.timer != null) {
      clearInterval(state.timer);
      state.timer = null;
    }
  }

  function registerRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (!root.isConnected) return;
    state.roots.add(root);
    updateRoot(root);
    if (state.timer == null) {
      state.timer = setInterval(tick, 1000);
    }
  }

  function scanDocument() {
    var found = document.querySelectorAll('[data-mellow-shipping-eta-root]');
    for (var i = 0; i < found.length; i++) {
      registerRoot(found[i]);
    }
  }

  function onSectionLoad(ev) {
    var t = ev && ev.target;
    if (!t || typeof t.querySelectorAll !== 'function') return;
    var inner = t.querySelectorAll('[data-mellow-shipping-eta-root]');
    if (!inner || inner.length === 0) return;
    for (var j = 0; j < inner.length; j++) {
      registerRoot(inner[j]);
    }
  }

  function bindSectionListener() {
    if (state.listeners) return;
    state.listeners = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  function init() {
    scanDocument();
    bindSectionListener();
  }

  window.__mellowShippingEtaRegister = registerRoot;

  if (state.domReadyBound) {
    init();
    return;
  }

  if (document.readyState === 'loading') {
    state.domReadyBound = true;
    document.addEventListener('DOMContentLoaded', init);
  } else {
    state.domReadyBound = true;
    init();
  }
})();
